import type { CuckooEvent } from "../../consts/enums"

export const EXPONEA_PAGE_LOADED: CuckooEvent = {
  category: "exponea",
  action: "Page loaded",
  destinations: { exponea: true },
  version: 1,
  // owner: "",
  // triggerCondition: "",
  // description: "",
}
export const EXPONEA_BOOKING_CONTACT: CuckooEvent = {
  category: "exponea",
  action: "bookingContact",
  destinations: { exponea: true },
  version: 1,
  // owner: "",
  // triggerCondition: "",
  // description: "",
}
export const EXPONEA_IDENTIFY: CuckooEvent = {
  category: "exponea",
  action: "identify",
  destinations: { exponea: true },
  version: 1,
  // owner: "",
  // triggerCondition: "",
  // description: "",
}
export const EXPONEA_SUBSCRIPTION: CuckooEvent = {
  category: "exponea",
  action: "subscription",
  destinations: { exponea: true },
  version: 1,
  // owner: "",
  // triggerCondition: "",
  // description: "",
}
